import React, {Component} from "react";
import {CSVReader} from "react-papaparse";

export default class CsvParser extends Component {
    constructor() {
        super();
        this.state = {
            results: [],
        };
    }

    handleSaveToPC = (jsonData, filename) => {
        const fileData = JSON.stringify(jsonData);
        const blob = new Blob([fileData], {type: "text/plain"});
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.download = `${filename}.json`;
        link.href = url;
        link.click();
    };

    handleOnDrop = data => {
        console.log("------------Drop--------------");
        const header = data[0].data;
        const length = data.length;
        const result = [];
        data.filter((item, index) => {
            if (index > 0) return item;
        })
            .filter(item => {
                if (item != "") return item;
            })
            .map((item, index) => {
                result[index] = {};
                item.data.map((subitem, subindex) => {
                    result[index][header[subindex]] = subitem;
                });
            });
        this.setState({
            results: result,
        });
        const filename = new Date().toLocaleDateString() + "_export";
        this.handleSaveToPC(result, filename);
        console.log("---------------------------");
    };

    handleOnError = (err, file, inputElem, reason) => {
        console.log(err);
    };

    handleOnRemoveFile = data => {
        console.log("---------------------------");
        console.log(data);
        console.log("---------------------------");
    };

    render() {
        return (
            <>
                <CSVReader addRemoveButton onDrop={this.handleOnDrop} onError={this.handleOnError} onRemoveFile={this.handleOnRemoveFile}>
                    <span className="text-black z-20">Drop CSV file here or click to upload.</span>
                </CSVReader>
            </>
        );
    }
}
